import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function MAX
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            adderFlag={20}
            labelBlock={'MAX'}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default MAX